import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  mform: FormGroup;
  nextUrl: any;
  viewpwd = false;
  subscription: Subscription;
  isLoading:boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private msServices:MessageService,
    private authService: AuthService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {
    this.mform = this.fb.group({
      username: ['', Validators.required],
      remember_client: [false],
      password: ['', Validators.required]
    });
  }

  ngOnInit() {
    var currentPath = this.route.snapshot.routeConfig.path == 'login';
    this.subscription = this.route.queryParams.subscribe(params => {
      if (params['next']) {
        if (this.authService.hasValidToken() && currentPath) {
          this.router.navigate(['/cit']);
        }

        else if (this.authService.hasValidToken() && !currentPath) {
          this.router.navigate([this.nextUrl]);
        }

        else {
          this.router.navigate(['/login']);
        }
      }
    });

    if (this.authService.hasValidToken()) {
      this.router.navigate(['/cit']);
    }

    else {
      this.router.navigate(['/login']);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onSubmit() {
    let fm = this.mform.value;
    if (this.mform.invalid || this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.authService.authenticate(fm.username, fm.password, fm.remember_client).subscribe(
      token => this.onSuccess(token),
      error => this.onError(error)
    );
  }

  onTogglePassword() {
    this.viewpwd = !this.viewpwd;
  }

  invalid(s: string) {
    const m = this.mform.controls[s];
    return m.invalid && (m.dirty || m.touched);
  }

  onSuccess(res) {
    this.msServices.send('home.index', { reload: true });
    if (this.nextUrl) {
      this.router.navigateByUrl(this.nextUrl)
        .catch(() => { this.router.navigate(['/cit']); });
    }
    else {
      this.router.navigate(['/cit']);
    }
    this.isLoading = false;
  }

  onError(error) {
    if (error == 'invalid_grant') {
      this.toastr.error('Invalid Username or Password', 'Login Failed', {
        positionClass: 'toast-top-center'
      });
    }
    this.isLoading = false;
  }
}
